import { Box, Button, Typography } from '@material-ui/core'

const WelcomeSlide = ({slideLoaded, nextSlide}) => {
  return (
    <>
      <Box marginBottom={2}>
        <Typography variant="h4">This is timed examination</Typography>
      </Box>
      <Box marginBottom={2}>
        <Typography variant="subtitle1">
          This exam has a total of 30 questions. Questions will be divided into pages. Each page contains X questions and you will be given X minutes to answer each page. Once the time is up, you will be redirected to the next page. You will not be able to go back to the previous page.
        </Typography>
      </Box>
      <Box>
        <Button variant="contained" color="primary" onClick={nextSlide}>
          Proceed to Exam &nbsp; <i className="fa fa-arrow-right"></i>
        </Button>
      </Box>
    </>
  )
}

export default WelcomeSlide